export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "exportations_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exportaciones"])},
          "containers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "schedule_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Programación"])},
          "summary_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resumen"])},
          "new_container_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo contenedor"])},
          "new_exportation_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva exportación"])},
          "general_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar reporte general"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "total_number_exportations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])}
        }
      }
    }
  })
}